export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/task-cards-pull-out.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/taskCardsPullOut.js